import biobarApi from './base/biobarApi';
import { getAuthorizationToken } from './fetchSessionToken';

import Notification from 'models/Notifications/Notification';
import NotificationCount from 'models/Notifications/NotificationCount';

export async function fetchNotificationsCount() : Promise<NotificationCount> {
  const { data } = await biobarApi.get<NotificationCount>('/notifications/unread/count', getAuthorizationToken());
  return data;
}

export async function fetchNotifications() : Promise<Array<Notification>> {
  const { data } = await biobarApi.get<Array<Notification>>('/notifications', getAuthorizationToken());
  return data;
}

export async function checkAllAsRead() : Promise<void> {
  await put('/notifications/read');
}

export async function checkAsRead(notificationId : number) : Promise<void> {
  await put(`/notifications/${notificationId}/read`);
}

async function put(path : string) : Promise<void> {
  await biobarApi({
    method: 'put',
    url: path,
    ...getAuthorizationToken(),
  });
}